/**
 * ACSolar type system.
 *
 * Montserrat (headings) and Inter (body) are loaded from Google Fonts in
 * `components/molecules/createHeader/CreateHead.js`. Every family carries a
 * real system fallback stack so the page stays legible before the webfont
 * lands, or if it never does.
 */

/** Headings — Montserrat. */
export const fontHeading =
  '"Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'

/** Body & UI — Inter. */
export const fontBody =
  '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'

/** Monospace — system stack only, nothing to load. */
export const fontMono =
  '"SFMono-Regular", Consolas, "Liberation Mono", monospace'

/**
 * Legacy alias. The previous system had a separate display face (Yeseva One);
 * headings and display now share Montserrat.
 */
export const fontDisplay = fontHeading

/** Weights, split by role so headings and body can diverge. */
export const fontWeight = {
  heading: {
    black: 800,
    bold: 700,
    semibold: 600,
  },
  body: {
    bold: 700,
    semibold: 600,
    medium: 500,
    regular: 400,
  },
}

/** Type scale (rem). */
export const fontSize = {
  xs: "0.75rem", // 12px
  sm: "0.875rem", // 14px
  base: "1rem", // 16px
  lg: "1.125rem", // 18px
  xl: "1.25rem", // 20px
  "2xl": "1.5rem", // 24px
  "3xl": "1.875rem", // 30px
  "4xl": "2.25rem", // 36px
  "5xl": "3rem", // 48px
  "6xl": "3.75rem", // 60px
}

export const lineHeight = {
  tight: 1.1,
  snug: 1.2,
  normal: 1.5,
  relaxed: 1.65,
}

export const letterSpacing = {
  tight: "-0.025em",
  normal: "0",
  wide: "0.025em",
  wider: "0.05em",
}

export const fonts = {
  heading: fontHeading,
  body: fontBody,
  mono: fontMono,
  display: fontHeading,
}

export default fonts
